module.exports = __webpack_public_path__ + "img/DNARepair-PRCA_10X_ANS.a75bd463.png";